import React, { useState,useLayoutEffect } from 'react'
import { Link, Redirect } from 'react-router-dom'
import InfoBarSRI from '../../components/InfoBarSRI/InfoBarSRI'
import queryString from "query-string"
import io from "socket.io-client"

import './avaliacao.css'

const ENDPOINT = `${process.env.REACT_APP_IP_SERVER_CHAT}`
let socket
const sentBy = "SRI"
const Avaliacao = ({location}) => {
    const [room, setRoom] = useState('');
    const [name, setName] = useState('');
    const [rate, setRate] = useState('');
    const [rateText, setRateText] = useState('');
    const [question, setQuestion] = useState('');
    const [colorRate, setColorRate] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [atendente, setAtendente] = useState('');
    const [isFinalizado, setIsFinalizado] = useState(false);

    let socket;

    useLayoutEffect(() => {
      async function socketConnect(){
        socket = await io(ENDPOINT, {
          path: '/server-chat'
        })
        return socket
      }
      socketConnect()

      const { name, room, atendente } = queryString.parse(location.search)
      setName(`${name}`);
      setRoom(`${room}`);
      setAtendente(`${atendente}`)
    })

    const handleRateStars = (e)=>{
      switch (e) {
        case "Ótimo":
        setRate("5")
        setRateText("Ótimo")
        setColorRate("#D4EDDA")
      break;
       case "Bom":
      setRate("4")
      setRateText("Bom")
      setColorRate("#fcdbfc")
      break;
       case "Satisfatório":
       setRate("3")
       setRateText("Satisfatório")
       setColorRate("#cce5ff")
       break;
      case "Ruim":
        setRate("2")
        setRateText("Ruim")
        setColorRate("#FFF3CD")
      break;
      case "Péssimo":
        setRate("1")
        setRateText("Péssimo")
        setColorRate("#F8D7DA")
        break;
      default:
          break;
      }
    }


    const handleSubmit = (e) =>{
      e.preventDefault();

      if(rate==="" || question ===""){
        setAlertMessage("*Existem campos em branco*")
      }else{
        setAlertMessage("")
        try{
          socket.emit("avaliacao", { name: name, room: room ,atendente: atendente.substring(2) , question: question , rateStar: rate, sentBy: sentBy }, ()=>{
            console.log( name, room, atendente)
            console.log( question +" - "+ rate   )
          setIsFinalizado(true)
          })

        }catch(err){
          console.log("Erro ao enviar avaliação: "+err)
          setAlertMessage("*Erro ao enviar avaliação*")
        }


      }

    }

    return (
    <>
      {isFinalizado===false?
        <>
      <InfoBarSRI/>
      <div className={"containerRating"}>
          <form onSubmit={(event)=> handleSubmit(event)}>
            <p><i>Chat finalizado!</i></p><br />
              <h4><b>Seu problema foi resolvido e/ou sua dúvida foi sanada?</b></h4>
              <div className={"question1"}>
              <input style={{height: "15px"}}type="radio" id="question1Sim" name="question1" value="sim" onClick={(event)=> setQuestion("Sim")}/>
              <label for="question1Sim">Sim</label><br/>
              <input style={{height: "15px"}} type="radio" id="question1Nao" name="question1" value="nao" onClick={(event)=> setQuestion("Não")}/>
              <label for="question1Nao">Não</label><br/>
              <input style={{height: "15px"}} type="radio" id="question1Parcial" name="question1" value="parcial" onClick={(event)=> setQuestion("Parcial")}/>
              <label for="question1Parcial">Parcialmente</label>
              </div>

              <div className={"titleRating"} style={{backgroundColor: colorRate}}>
              <h4>Avalie nosso atendimento: </h4>
              {rateText}
              </div>
              <div className={"rating"}>
                <input type={"radio"} name="star" id="star1" onClick={(event)=> handleRateStars("Ótimo") }/><label  htmlFor="star1"></label>
                <input type={"radio"} name="star" id="star2" onClick={(event)=> handleRateStars("Bom")}/><label htmlFor="star2"></label>
                <input type={"radio"} name="star" id="star3" onClick={(event)=> handleRateStars("Satisfatório")}/><label htmlFor="star3"></label>
                <input type={"radio"} name="star" id="star4" onClick={(event)=> handleRateStars("Ruim")}/><label htmlFor="star4"></label>
                <input type={"radio"} name="star" id="star5" onClick={(event)=> handleRateStars("Péssimo")}/><label htmlFor="star5"></label>
              </div>
              <button className={"BtnSendRating"} type={"submit"}>
                Enviar
              </button>
              <p style={{color: "red", margin: "5px"}}>{alertMessage}</p>
          </form>
      </div>
       </>
        :
        <Redirect to={{
          pathname: "/start",
          search: `?name=${name}&room=${room}`
        }} />
      }
      </>
    )
  }

export default Avaliacao;
